<template>
  <v-layout 
    column
  >
    <v-row 
      v-for="(localizedMessage, idx) in message.localized"
      :key="localizedMessage.uuid"
    >
      <BackendLocalizedMessage 
        :editionMode="editionMode" 
        :localizedMessage="localizedMessage"
        :localizedMessageIdx="idx"
        :remainingLanguages="remainingLanguages"
        :jsonpath="`${jsonpath}.localized[${idx}]`"
        @change="localizedMessageChanged"
        @delete="localizedMessageDeleted"
      ></BackendLocalizedMessage>
    </v-row>
    <v-row 
      v-if="editionMode && remainingLanguages.length != 0"
    >
      <a @click="addTranslation">{{ $t('messages.label.addTranslation') }}</a>
    </v-row>
  </v-layout>
</template>

<script>
import BackendLocalizedMessage from "./BackendLocalizedMessage"
import { v4 as uuidv4 } from 'uuid';

export default {
  props: ["editionMode", "messageIdx", "message", "availableLanguages", "jsonpath"],
  components: {
    BackendLocalizedMessage,
  },
  data(){
    return {
      nbLocalized: 0, 
    }
  },
  mounted() {
    this.nbLocalized = this.message.localized.length
  },
  computed: {
    remainingLanguages() {
      const result = [...this.availableLanguages];
      for (let localizedMessage of this.message.localized) {
        const index = result.indexOf(localizedMessage.language);
        if (index != -1) {
          result.splice(index, 1)
        }
      }
      return result;
    }
  },
  methods: {
    localizedMessageChanged(event) {
      this.$emit("change", event)
    },
    localizedMessageDeleted(event) {
      this.$emit("change", { jsonpath: `${this.jsonpath}.localized`, op: { name: "remove", value : event }})
      this.nbLocalized--;
      if (this.nbLocalized == 0) {
        this.$emit("delete", this.messageIdx)
      }
    },
    addTranslation() {
      this.nbLocalized++;
      this.$emit("change", { jsonpath: `${this.jsonpath}.localized`, op: { name: "add", value: { 
        uuid: uuidv4(), 
        language: this.remainingLanguages[0], 
        title: "", 
        body: "" 
      }}});
    }
  }
}
</script>